import { useEffect, useState } from 'react';

import { useHistory, useLocation } from 'react-router';

import AuthService from 'domain/services/authentication';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { IDENTITY_ENDPOINT } from 'utils/constants';
import { getUser, setUser } from 'redux/authentication/auth.slice';

export default function useSignUp() {
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { search } = useLocation();
  const refreshToken = new URLSearchParams(search).get('refresh_token');
  const user = useAppSelector(getUser);

  const storageProvider = localStorage.getItem('provider');

  function passwordCheck() {
    if (password.length === 0) {
      setError('Please add password');
      return false;
    }
    if (password !== repeatPassword) {
      setError('Password and Repeat password are not matching, please try again.');
      return false;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 charachters long.');
      return false;
    }
    return true;
  }

  async function SignUpWithPassword() {
    try {
      await AuthService.PasswordSignUp(password);
    } catch (err) {
      setError(err);
    } finally {
      if (user) {
        localStorage.setItem('user', JSON.stringify(user));
        dispatch(setUser(user));
        history.push('/');
      }
    }
  }

  async function checkForUserBeforeProceed() {
    const currentUser = await AuthService.SignUpCheckForUser();
    if (currentUser.is_verified) {
      localStorage.setItem('user', JSON.stringify(currentUser));
      dispatch(setUser(currentUser));
      history.push('/');
      return false;
    }
    return true;
  }

  const SignUp = async (provider: string) => {
    if (!storageProvider && provider === 'PASSWORD' && !passwordCheck()) {
      return;
    }
    setLoading(true);
    try {
      const proceed = await checkForUserBeforeProceed();

      if (!proceed) {
        return;
      }
      if (storageProvider) {
        localStorage.removeItem('provider');
      } else {
        localStorage.setItem('provider', provider);
      }

      switch (provider) {
        case 'GOOGLE':
          window.location.replace(`${IDENTITY_ENDPOINT}/providers/google`);
          break;
        case 'FACEBOOK':
          window.location.replace(`${IDENTITY_ENDPOINT}/providers/facebook`);
          break;
        case 'APPLE':
          window.location.replace(`${IDENTITY_ENDPOINT}/providers/apple`);
          break;
        default:
          SignUpWithPassword();
      }
    } catch (err) {
      // TO DO error handeling
      // eslint-disable-next-line no-console
      console.error('Signup error', err);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!refreshToken) {
      return;
    }
    if (user) {
      dispatch(setUser(user));
      return;
    }
    if (storageProvider) {
      SignUp(storageProvider);
    }
  }, []);

  useEffect(() => {
    setError(false);
  }, [password, repeatPassword]);

  async function GetMe() {
    try {
      await AuthService.getMe();
    } catch (err) {
      setError(err);
    }
  }

  return {
    isLoading,
    error,
    password,
    repeatPassword,
    SignUp,
    setPassword,
    setRepeatPassword,
    GetMe,
  };
}
